import { getInstance } from './authWrapper';

// Ensures that if the user has the app open in more than one tab/window, and the user
// logs out in one of these tabs/windows, the user will also be logged out of the app
// in the other tabs/windows.
window.onstorage = e => {
  // `clear()` has been run on localStorage if the 'storage' event's `key` is `null`.
  const storageCleared = e.key == null;
  // The Auth0 localStorage entry has been cleared if the 'storage' event's `key` is
  // the Auth0 key and the `value` is `null`.
  const auth0EntryRemoved = /^@@auth0spajs@@/.test(e.key) && e.newValue == null;

  // Log the user out in the current tab/window's app instance if the user has logged
  // out somewhere else (i.e. the Auth0 localStorage entry has been removed or the whole
  // localStorage has been cleared).
  if (auth0EntryRemoved || storageCleared) {
    getInstance().logout({ returnTo: window.location.origin });
  }
};
